'use client';

import React, { useState, useEffect } from 'react';
import { PageType, useGTM } from '@/features/Analytics';
import { Navbar } from '@/widgets/Navbar';
import type { NavbarLink } from '@/widgets/Navbar';
enum NavbarIds {
  HOME = 'home',
  REVIEW = 'review',
  SERVICES = 'services',
  LECHENIE = 'lechenie',
  ABOUT_DOCTOR = 'about_doctor',
  BOOK = 'book',
}
enum SectionIds {
  HOME = '#home',
  REVIEW = '#review',
  SERVICES = '#services',
  LECHENIE = '#lechenie',
  ABOUT_DOCTOR = '#about_doctor',
  BOOK = '#book',
}
const navbarLinks: NavbarLink[] = [{
  href: SectionIds.HOME,
  id: NavbarIds.HOME,
  label: 'doctor.navbar.main'
}, {
  href: SectionIds.REVIEW,
  id: NavbarIds.REVIEW,
  label: 'doctor.navbar.reviews'
}, {
  href: SectionIds.SERVICES,
  id: NavbarIds.SERVICES,
  label: 'doctor.navbar.services'
}, {
  href: SectionIds.LECHENIE,
  id: NavbarIds.LECHENIE,
  label: 'doctor.navbar.treatment'
}, {
  href: SectionIds.ABOUT_DOCTOR,
  id: NavbarIds.ABOUT_DOCTOR,
  label: 'doctor.navbar.about'
}];
interface Props {
  totalReviews: number;
  className?: string;
}
export const DoctorNavbar: React.FC<Props> = ({
  totalReviews,
  className
}) => {
  const {
    trackEvent
  } = useGTM(PageType.DOCTOR_PROFILE);
  const [navbarLinksList, setNavbarLinksList] = useState<NavbarLink[]>([]);
  const sendAnalytics = (id: string) => {
    const eventNames = {
      [SectionIds.HOME]: 'click_navbar_main',
      [SectionIds.REVIEW]: 'click_doctor_review_tab',
      [SectionIds.SERVICES]: 'click_doctor_services_tab',
      [SectionIds.LECHENIE]: 'click_doctor_treatment_tab',
      [SectionIds.ABOUT_DOCTOR]: 'click_about_doctor',
      [SectionIds.BOOK]: 'click_navbar_book'
    };
    trackEvent(eventNames[id as SectionIds]);
  };
  const updateNavbarLinks = () => {
    const newItems = navbarLinks.filter(item => document.querySelector(item.href)).map(item => {
      if (item.id === NavbarIds.REVIEW) {
        return {
          ...item,
          label: {
            key: 'doctor.navbar.reviews',
            data: {
              count: totalReviews
            }
          }
        };
      }
      return item;
    });
    setNavbarLinksList(newItems);
  };
  useEffect(() => {
    updateNavbarLinks();
  }, []);
  return <Navbar sendAnalytics={sendAnalytics} navbarLinksList={navbarLinksList} className={className} data-sentry-element="Navbar" data-sentry-component="DoctorNavbar" data-sentry-source-file="DoctorNavbar.tsx" />;
};